import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-job-details',
  templateUrl: './list-job-details.component.html',
  styleUrls: ['./list-job-details.component.scss']
})
export class ListJobDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
